module.exports = __webpack_public_path__ + "static/media/iPhone13_wish.14f6379a.png";